import {
  DIALOG_TYPES,
  DEACTIVATE_DIALOG
} from "./BranchDeployer.consts";

const useBranchDeployerDialog = ({ type, data }) => {
  let dialogContent = {};

  if (type === DIALOG_TYPES.deactivate.id) {
    dialogContent = {
      title: DEACTIVATE_DIALOG.title,
      subtitle: DEACTIVATE_DIALOG.subtitle.replace("$branchDeployerName", data.releaseName),
      actionButtonText: DEACTIVATE_DIALOG.buttonText
    };
  }

  return { dialogContent };
};

export default useBranchDeployerDialog;
